export enum modulePermissionsNames {
  SET_PERMISSIONS = "SET_PERMISSIONS",
  SET_PERMISSIONS_OBJ = "SET_PERMISSIONS_OBJ",
  SET_PERMISSIONS_PAGE = "SET_PERMISSIONS_PAGE",
}
